import { faFileAlt } from "@fortawesome/free-solid-svg-icons";
import saveAs from "file-saver";
import { useUserInfor } from "../../../Context/User";
import { ExportarRelatorioPDFControleManutencaoDiaController } from "../../../Controllers/AssistenciaTecnica/Atendimento/RelatorioControle/RelatorioControleManutencaoControllers";
import { ListarUsuariosMesmoProdutoController } from "../../../Controllers/Geral/GestaoUsuarios/UsuariosController";
import useAsyncCallback from "../../../hooks/useAsyncCallback";
import UnForm from "../../Form";

interface IGerarRelatorioManutencaoProps {
    sistema: boolean;
}

interface IFormData {
    DT_INICIO: string;
    DT_FIM: string;
    ID_USUARIO: number;
}

export default function GerarRelatorioManutencao(
    props: IGerarRelatorioManutencaoProps
) {
    const { UserInfor } = useUserInfor();

    const {
        execute: gerarRelatorioManutencaoDia,
        loading: gerarRelatorioManutencaoDiaLoading,
    } = useAsyncCallback(ExportarRelatorioPDFControleManutencaoDiaController);

    function handleGerarRelatorioManutencao(formData: IFormData) {
        gerarRelatorioManutencaoDia(
            props.sistema,
            formData.DT_INICIO,
            formData.DT_FIM,
            formData.ID_USUARIO
        ).then((res) => {
            saveAs(
                new Blob([res], {
                    type: "application/pdf",
                }),
                `Relatórios de Controle AT do dia`
            );
        });
    }
    const todaysDate = new Date().toISOString().substring(0, 10);

    return (
        <div>
            <UnForm handleSubmit={handleGerarRelatorioManutencao}>
                <UnForm.Input
                    type={"date"}
                    name="DT_INICIO"
                    defaultValue={todaysDate}
                    label="Data Início"
                    className="mb-2"
                />
                <UnForm.Input
                    type={"date"}
                    name="DT_FIM"
                    defaultValue={todaysDate}
                    label="Data Fim"
                    className="mb-4"
                />
                <UnForm.LazySelect
                    getDS={(u) => u.DS_NOME}
                    getKeyValue={(u) => u.ID_USUARIO}
                    controller={ListarUsuariosMesmoProdutoController}
                    name="ID_USUARIO"
                    defaultValue={UserInfor.ID_USUARIO}
                    label="Usúario"
                    className="mb-4"
                />
                <UnForm.SubmitButton
                    loading={gerarRelatorioManutencaoDiaLoading}
                    icon={faFileAlt}
                    color={"primary"}
                    outline={true}
                    className="col-12"
                    wrapperClassName="col-12 m-0 p-0"
                    loadingSize="sm"
                >
                    Gerar Relatório AT
                </UnForm.SubmitButton>
            </UnForm>
        </div>
    );
}
